import {vec2,distance} from './core'
import {Bodies,Body} from 'matter-js'

export function createPetriDish(x,y,radius,resolution){
    let dish = []
    let step = 2*Math.PI/resolution
    for(let i = 0; i < resolution;i++){
        let x1 = Math.cos(step*i) * radius + x
        let y1 = Math.sin(step*i) * radius + y
        let x2 = Math.cos(step*(i+1)) * radius + x
        let y2 = Math.sin(step*(i+1)) * radius + y
        let d = distance(vec2(x1,y1),vec2(x2,y2))
        let r = Bodies.rectangle(x1,y1,d,20,{isStatic:true})
        Body.rotate(r,step*i+Math.PI*.5)
        r.width = d
        dish.push(r)
    }
    return dish
}